// dateFormet.js

class DateFormet {
  static formatDate(dateString) {
      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
          return "--"; // Return "--" if the date is not a valid date
      }

      const day = date.getDate().toString().padStart(2, '0');
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();

      return `${day} ${month} ${year}`;
  }
}

export default DateFormet;
